import numeral from 'numeral'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import {
  paymentMethodSelected,
  phaseChange,
  reroute,
  storeDumpItForce,
} from '../../../actions/Buy'
import {
  getLogisticaCentriConvenzionatiNltBrumbrum,
  setLogisticaCentroConvenzionato,
  setLogisticaCodiceProvincia,
} from '../../../actions/buy/Logistica'
import { getNltServiziPlusV1 } from '../../../actions/noleggia/Nlt'
import {
  putOrdiniLogisticaV1,
  putOriniServiziPlusV1,
} from '../../../actions/noleggia/Ordini'
import {
  setSelectedServizio,
  unSetAllServiziPlus,
  unSetSelectedServizio,
} from '../../../actions/noleggia/ServiziPlus'
import { EnhancedEcommerceMapper } from '../../../tracking/EnhancedEcommerce/mapper'
import { enhancedEcommerceTracker } from '../../../tracking/EnhancedEcommerce/tracker'
import { getFromFee, isNltBrumbrum } from '../../../utils/nltUtils'
import BuyButton from '../../buy/dumb/BuyButton'
import BuyCartRow from '../../buy/dumb/BuyCartRow'
import BuyCheckboxInput from '../../buy/dumb/BuyCheckboxInput'
import BuyPricePromozione from '../../buy/dumb/BuyPricePromozione'
import BuyPricePromozioneVertical from '../../buy/dumb/BuyPricePromozioneVertical'
import BuyRadioInput from '../../buy/dumb/BuyRadioInput'
import BuySelectInput2 from '../../buy/dumb/BuySelectInput2'
import {
  preparaValoriLogistica,
  restartSellout,
  restartSelloutCheckpoints,
} from '../../buy/utils'
import MiniCartNlt from '../dumb/MinicartNlt'
import ServiziInclusi from '../dumb/ServiziInclusi'

class ServiziPlus extends Component {
  constructor(props) {
    super(props)
    this.state = {
      canContinue: false,
      centriConvenzionati: [],
      isEECTracked: false,
    }

    this.handleLogisticaSelected = this.handleLogisticaSelected.bind(this)
    this.handleProvinciaLogisticaSelected =
      this.handleProvinciaLogisticaSelected.bind(this)
    this.isLogististicaDisabled = this.isLogististicaDisabled.bind(this)
    this.getSelectedLogistica = this.getSelectedLogistica.bind(this)

    this.isNltBrumbrum = isNltBrumbrum(this.props.product)
  }

  componentDidMount() {
    this.props.phaseChange({ phase: 20, last: 10 })
    if (
      !restartSellout(
        restartSelloutCheckpoints.SERVIZI_PLUS,
        this.props.reroute,
        this.props.customer
      )
    ) {
      this.props
        .getNltServiziPlusV1()
        .then(json => {
          if (!json.result.length) {
            // BRUM-10389 in assenza di servizi si skippa la
            // schermata solo per nlt arval per nlt bb c'e' la scelta consegna
            if (!this.isNltBrumbrum) {
              this.props.reroute('/richiesta-noleggio')
            } else {
              // si aggiornano i dati per recupero carrello
              // perche' nlt bb rimane su questa pagina
              this.props.storeDumpItForce()
            }
          } else {
            // si aggiornano i dati per recupero carrello
            this.props.storeDumpItForce()
          }
        })
        .catch(() => {
          // BRUM-8727 se i servizi vanno in errore
          // proseguiamo indefessi
          this.props.paymentMethodSelected({ method: 'noleggio' })
          this.props.reroute('/richiesta-noleggio')
        })
    }

    if (
      this.isNltBrumbrum &&
      (!this.props.logistica.centro_convenzionato ||
        (this.props.logistica.centro_convenzionato &&
          !this.props.logistica.centro_convenzionato.nome_provincia))
    ) {
      this.props.getLogisticaCentriConvenzionatiNltBrumbrum().catch(() => null)
    }

    if (!this.state.isEECTracked) {
      this.setState(
        {
          isEECTracked: true,
        },
        () =>
          enhancedEcommerceTracker
            .pushCheckout(
              {
                product: this.props.product,
                ordine: this.props.ordine,
                nlt: this.props.nlt,
              },
              2
            )
            .then(() => {})
      )
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.logistica &&
      nextProps.logistica.centri_convenzionati_by_provincia &&
      !this.state.centriConvenzionati.length
    ) {
      this.setState({
        centriConvenzionati: Object.keys(
          nextProps.logistica.centri_convenzionati_by_provincia
        ).map(codiceProvincia => {
          const _ = {
            label:
              nextProps.logistica.centri_convenzionati_by_provincia[
                codiceProvincia
              ].label,
            value:
              nextProps.logistica.centri_convenzionati_by_provincia[
                codiceProvincia
              ].value,
          }
          return _
        }),
      })
    }
  }

  handleLogisticaSelected() {
    return event => {
      const nomeCentroConvenzionato = event.target.value
      this.props.setLogisticaCentroConvenzionato(
        this.props.logistica.centri_convezionati[nomeCentroConvenzionato]
      )
    }
  }

  handleProvinciaLogisticaSelected() {
    const _this = this
    return (event, create) => {
      const codice_provincia_logistica = event.value
      if (codice_provincia_logistica) {
        if (create === true) {
          this.state.centriConvenzionati.push(event)
          this.setState({
            centriConvenzionati: this.state.centriConvenzionati,
            provinciaLogistica: event,
          })
          _this.props.setLogisticaCentroConvenzionato(null)
          // HANDLE UNDEFINED
        } else if (codice_provincia_logistica !== 'NOT_FOUND') {
          _this.props.setLogisticaCodiceProvincia(codice_provincia_logistica)
          this.setState({ provinciaLogistica: event })
          // seleziono il primo centro di consegna per questa provincia
          const nome_centro_consegna =
            _this.props.logistica.centri_convenzionati_by_provincia[
              codice_provincia_logistica
            ].modalita[0].nome
          _this.props.setLogisticaCentroConvenzionato(
            _this.props.logistica.centri_convezionati[nome_centro_consegna]
          )

          this.setState({ canContinue: true })
        } else {
          this.setState({
            provinciaLogistica: event,
          })
          _this.props.setLogisticaCentroConvenzionato(null)
          // HANDLE UNDEFINED
        }
      }
    }
  }

  isLogististicaDisabled() {
    /**
     * se ho un ordine gia' creato
     * non posso variare la logistica
     */
    return false
  }

  getSelectedLogistica(attr) {
    /**
     * se non ho gia' creato un ordine con un centro e' Milano
     * altrimenti e' il centro convenzionato selezionato
     */
    if (this.props.logistica.centro_convenzionato) {
      return this.props.logistica.centro_convenzionato[attr]
      // eslint-disable-next-line no-else-return
    } else {
      // ritorno il primo centro convenzionato della lista
      return this.props.logistica.centri_convezionati[
        Object.keys(this.props.logistica.centri_convezionati)[0]
      ][attr]
    }
  }

  handleProsegui = async () => {
    if (this.isNltBrumbrum) {
      await this.props.putOrdiniLogisticaV1()

      this.props.paymentMethodSelected({ method: 'noleggio' })
      enhancedEcommerceTracker
        .pushCheckoutOption(2, this.props.logistica.centro_convenzionato?.nome)
        .then(() => {})
      this.props.reroute('/richiesta-noleggio')

      return
    }

    await this.props.putOriniServiziPlusV1()

    enhancedEcommerceTracker
      .pushCheckoutOption(
        2,
        EnhancedEcommerceMapper.mapSelectedVas({
          nlt: this.props.nlt,
          product: this.props.product,
        })
      )
      .then(() => {})
    this.props.paymentMethodSelected({ method: 'noleggio' })
    this.props.reroute('/richiesta-noleggio')
  }

  handleSelezionaServizioPlus(servizioPlus) {
    const t = this
    return event => {
      if (event.target.checked) {
        t.props.setSelectedServizio(servizioPlus)
      } else {
        t.props.unSetSelectedServizio(servizioPlus)
      }
    }
  }

  isServizioPlusChecked(servizioPlus) {
    return (
      this.props.nlt.serviziPlusSelected.indexOf(servizioPlus.id_servizio) !==
      -1
    )
  }

  totale() {
    return this.props.pricing.total
  }

  render() {
    const valoriLogistica = preparaValoriLogistica(
      this.totale(),
      this.props.logistica
    )

    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth

    const isMobile = width <= 868 && width >= 280

    const { product } = this.props
    return (
      <section className="relative process serviziPlus">
        {/* <div className="process__header"> */}
        {/* <h1 */}
        {/* className="process__title" */}
        {/* >Riepilogo dei tuoi servizi</h1> */}
        {/* </div> */}
        {!isMobile ? (
          <div className="user-informations hide-small">
            <div className="container_small">
              <div className="process__column process__column__right right_tre_colonne colonna_uno">
                <ServiziInclusi
                  canone={
                    this.props.nlt && this.props.nlt.selectedCanone
                      ? this.props.nlt.selectedCanone
                      : undefined
                  }
                  product={this.props.product}
                />
              </div>

              {this.isNltBrumbrum ? (
                <div
                  className="process__column process__column__center colonna_due"
                  id="servizi-plus-consegna-auto"
                >
                  <div className="box-elementi">
                    <div className={'section-cart'}>
                      <h5 className={'section-title --reduced'}>
                        Consegna della tua auto
                      </h5>
                      {Object.keys(this.props.logistica.centri_convezionati)
                        .length ? (
                        <BuyCartRow
                          extraCss="select-dropdown no-border-bottom"
                          hideRight
                          label="Città"
                        >
                          <BuySelectInput2
                            async={false}
                            creatable={false}
                            defaultValue={this.getSelectedLogistica(
                              'codice_provincia'
                            )}
                            disabled={this.isLogististicaDisabled()}
                            formatCreateLabel={inputValue => inputValue}
                            liClassName={'cart_select_logistica wide'}
                            onCreateOption={inputValue => {
                              this.handleProvinciaLogisticaSelected()(
                                { value: 'NOT_FOUND', label: inputValue },
                                true
                              )
                            }}
                            placeholder={'Seleziona la Provincia'}
                            update={this.handleProvinciaLogisticaSelected()}
                            value={this.state.provinciaLogistica}
                            values={this.state.centriConvenzionati}
                          />
                        </BuyCartRow>
                      ) : null}

                      {!!Object.keys(this.props.logistica.centri_convezionati)
                        .length &&
                        !!this.props.logistica.codice_provincia &&
                        this.state.provinciaLogistica &&
                        this.state.provinciaLogistica.value !== 'NOT_FOUND' && (
                          <BuyCartRow
                            extraCss="modalita_consegna"
                            hideRight
                            label="Modalità"
                          >
                            <div id={'logistica_modalita_consegna'}>
                              <ul className="data-form active">
                                <BuyRadioInput
                                  defaultValue={this.getSelectedLogistica(
                                    'nome'
                                  )}
                                  disabled={this.isLogististicaDisabled()}
                                  label={'modalita di consegna '}
                                  liClassName={'modalita_consegna_li'}
                                  pricePromozione={
                                    <BuyPricePromozioneVertical
                                      {...valoriLogistica}
                                      // questo dovrebbe essere prezzoLogisticaPromozione={"€ 0"} per centro convenzionato
                                    />
                                  }
                                  spanClass="value small"
                                  update={this.handleLogisticaSelected()}
                                  values={this.props.logistica.centri_convenzionati_by_provincia[
                                    this.props.logistica.codice_provincia
                                  ].modalita.map(centro => ({
                                    label:
                                      centro.tipologia_consegna_frontend ||
                                      centro.tipologia_consegna,
                                    value: centro.nome,
                                    description: () => {
                                      switch (centro.tipologia_consegna) {
                                        case 'Ritiro in garage':
                                        case 'Spedizione':
                                          return 'Raggiungi il centro per il ritiro dell’auto. Il nostro Servizio Clienti ti fornirà tutte le informazioni di cui hai bisogno.'
                                        case 'Consegna a casa':
                                          return 'Un nostro Specialista di Consegna porterà l’auto direttamente all’indirizzo che hai indicato'
                                        default:
                                          return centro.tipologia_consegna
                                      }
                                    },
                                  }))}
                                />
                              </ul>
                            </div>
                          </BuyCartRow>
                        )}

                      {this.state.provinciaLogistica &&
                        this.state.provinciaLogistica.value === 'NOT_FOUND' && (
                          <BuyCartRow
                            extraCss="modalita_consegna"
                            label="Modalità"
                          >
                            <div id={'logistica_modalita_consegna_non_trovata'}>
                              Nella tua città non è ancora presente un centro
                              convenzionato con brumbrum.
                              <br />
                              Sarai contattato dal nostro servizio clienti per
                              concordare la modalità e il luogo più comodi per
                              il ritiro
                            </div>
                          </BuyCartRow>
                        )}
                    </div>
                  </div>
                </div>
              ) : null}

              {this.props.nlt.serviziPlus.length ? (
                <div className="process__column process__column__center colonna_due">
                  <h5 className="section-title --reduced">
                    Vuoi aggiungere servizi plus?
                  </h5>
                  <div className="box-elementi">
                    {this.props.nlt.serviziPlus.map(servizioPlus => {
                      const label = (
                        <div
                          className="service-box-label"
                          key={`${servizioPlus.id_servizio}_inner`}
                        >
                          <div className={'box-left'}>
                            <h6>{servizioPlus.tipologia}</h6>
                            <p
                              dangerouslySetInnerHTML={{
                                __html: servizioPlus.descrizione,
                              }}
                            />
                          </div>
                          <div className={'box-right'}>
                            <small>al mese</small>
                            <b>
                              <small>€</small>
                              {servizioPlus.canone_extra}
                            </b>
                          </div>
                        </div>
                      )
                      return (
                        <BuyCheckboxInput
                          checked={this.isServizioPlusChecked(servizioPlus)}
                          classes={'r-checkbox long'}
                          key={servizioPlus.id_servizio}
                          label={[label]}
                          update={this.handleSelezionaServizioPlus(
                            servizioPlus
                          )}
                          value={this.isServizioPlusChecked(servizioPlus)}
                        />
                      )
                    })}

                    <BuyCheckboxInput
                      checked={
                        !this.props.nlt.serviziPlusSelected.length
                          ? this.state.canContinue
                          : false
                      }
                      classes={'r-checkbox long'}
                      label={[
                        <div className="service-box-label">
                          <div className="box-left">
                            <h6>Non sono interessato a nessun Servizio Plus</h6>
                          </div>
                        </div>,
                      ]}
                      update={event => {
                        if (event.target.checked) {
                          this.props.unSetAllServiziPlus()
                          this.setState({ canContinue: true })
                        }
                      }}
                      value={
                        !this.props.nlt.serviziPlusSelected.length
                          ? this.state.canContinue
                          : false
                      }
                    />
                  </div>
                </div>
              ) : null}
              {product.id_auto && (
                <div className="process__column process__column__right right_tre_colonne colonna_tre">
                  <MiniCartNlt
                    {...valoriLogistica}
                    nlt={this.props.nlt}
                    product={product}
                    ui={this.props.ui}
                  />
                  <div className="space-20"></div>
                  <p className="text-center">
                    <BuyButton
                      classes={`btn btn-primary${
                        this.props.fetching ||
                        (!this.props.nlt.serviziPlusSelected.length &&
                          !this.state.canContinue)
                          ? ' btn-disabled'
                          : ''
                      }`}
                      disabled={
                        !this.props.nlt.serviziPlusSelected.length &&
                        !this.state.canContinue
                      }
                      label={"Prosegui con l'ordine"}
                      update={() => {
                        if (
                          !this.props.nlt.serviziPlusSelected.length &&
                          !this.state.canContinue
                        ) {
                          return false
                        }

                        this.handleProsegui().then(() => {})
                      }}
                    />
                  </p>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="user-informations hide-large">
            <div className="container_small">
              {this.props.nlt.serviziPlus.length ? (
                <div className="process__column process__column__center colonna_due">
                  <h5 className="section-title --reduced">
                    Vuoi aggiungere servizi plus?
                  </h5>
                  <div className="box-elementi">
                    {this.props.nlt.serviziPlus.map(servizioPlus => {
                      const label = (
                        <div
                          className="service-box-label"
                          key={`${servizioPlus.id_servizio}_inner`}
                        >
                          <div className={'box-left'}>
                            <h6>{servizioPlus.tipologia}</h6>
                            <p
                              dangerouslySetInnerHTML={{
                                __html: servizioPlus.descrizione,
                              }}
                            />
                          </div>
                          <div className={'box-right'}>
                            <small>al mese</small>
                            <b>
                              <small>€</small>
                              {servizioPlus.canone_extra}
                            </b>
                          </div>
                        </div>
                      )
                      return (
                        <BuyCheckboxInput
                          checked={this.isServizioPlusChecked(servizioPlus)}
                          classes={'r-checkbox long'}
                          key={servizioPlus.id_servizio}
                          label={[label]}
                          update={this.handleSelezionaServizioPlus(
                            servizioPlus
                          )}
                          value={this.isServizioPlusChecked(servizioPlus)}
                        />
                      )
                    })}

                    <BuyCheckboxInput
                      checked={
                        !this.props.nlt.serviziPlusSelected.length
                          ? this.state.canContinue
                          : false
                      }
                      classes={'r-checkbox long'}
                      label={[
                        <div className="service-box-label">
                          <div className="box-left">
                            <h6>Non sono interessato a nessun Servizio Plus</h6>
                          </div>
                        </div>,
                      ]}
                      update={event => {
                        if (event.target.checked) {
                          this.props.unSetAllServiziPlus()
                          this.setState({ canContinue: true })
                        }
                      }}
                      value={
                        !this.props.nlt.serviziPlusSelected.length
                          ? this.state.canContinue
                          : false
                      }
                    />
                  </div>
                </div>
              ) : null}

              <div className="process__column process__column__center colonna_uno">
                <div className="hide-small">
                  <ServiziInclusi
                    canone={
                      this.props.nlt && this.props.nlt.selectedCanone
                        ? this.props.nlt.selectedCanone
                        : undefined
                    }
                    product={this.props.product}
                  />
                </div>

                {this.isNltBrumbrum ? (
                  <div
                    className="process__column process__column__center colonna_due"
                    id="servizi-plus-consegna-auto"
                  >
                    <div className="box-elementi">
                      <div className={'section-cart'}>
                        <h5 className={'section-title --reduced'}>
                          Consegna della tua auto
                        </h5>
                        {Object.keys(this.props.logistica.centri_convezionati)
                          .length ? (
                          <BuyCartRow
                            extraCss="select-dropdown no-border-bottom"
                            hideRight
                            label="Città"
                          >
                            <BuySelectInput2
                              async={false}
                              creatable={false}
                              defaultValue={this.getSelectedLogistica(
                                'codice_provincia'
                              )}
                              disabled={this.isLogististicaDisabled()}
                              formatCreateLabel={inputValue => inputValue}
                              liClassName={'cart_select_logistica wide'}
                              onCreateOption={inputValue => {
                                this.handleProvinciaLogisticaSelected()(
                                  { value: 'NOT_FOUND', label: inputValue },
                                  true
                                )
                              }}
                              placeholder={'Seleziona la Provincia'}
                              update={this.handleProvinciaLogisticaSelected()}
                              value={this.state.provinciaLogistica}
                              values={this.state.centriConvenzionati}
                            />
                          </BuyCartRow>
                        ) : null}

                        {!!Object.keys(this.props.logistica.centri_convezionati)
                          .length &&
                          !!this.props.logistica.codice_provincia &&
                          this.state.provinciaLogistica &&
                          this.state.provinciaLogistica.value !==
                            'NOT_FOUND' && (
                            <BuyCartRow
                              extraCss="modalita_consegna"
                              hideRight
                              label="Modalità"
                            >
                              <div id={'logistica_modalita_consegna'}>
                                <ul className="data-form active">
                                  <BuyRadioInput
                                    defaultValue={this.getSelectedLogistica(
                                      'nome'
                                    )}
                                    disabled={this.isLogististicaDisabled()}
                                    label={'modalita di consegna '}
                                    liClassName={'modalita_consegna_li'}
                                    pricePromozione={
                                      <BuyPricePromozioneVertical
                                        {...valoriLogistica}
                                        // questo dovrebbe essere prezzoLogisticaPromozione={"€ 0"} per centro convenzionato
                                      />
                                    }
                                    spanClass="value small"
                                    update={this.handleLogisticaSelected()}
                                    values={this.props.logistica.centri_convenzionati_by_provincia[
                                      this.props.logistica.codice_provincia
                                    ].modalita.map(centro => ({
                                      label:
                                        centro.tipologia_consegna_frontend ||
                                        centro.tipologia_consegna,
                                      value: centro.nome,
                                      description: () => {
                                        switch (centro.tipologia_consegna) {
                                          case 'Ritiro in garage':
                                          case 'Spedizione':
                                            return 'Raggiungi il centro per il ritiro dell’auto. Il nostro Servizio Clienti ti fornirà tutte le informazioni di cui hai bisogno.'
                                          case 'Consegna a casa':
                                            return 'Un nostro Specialista di Consegna porterà l’auto direttamente all’indirizzo che hai indicato'
                                          default:
                                            return centro.tipologia_consegna
                                        }
                                      },
                                    }))}
                                  />
                                </ul>
                              </div>
                            </BuyCartRow>
                          )}

                        {this.state.provinciaLogistica &&
                          this.state.provinciaLogistica.value ===
                            'NOT_FOUND' && (
                            <BuyCartRow
                              extraCss="modalita_consegna"
                              label="Modalità"
                            >
                              <div
                                id={'logistica_modalita_consegna_non_trovata'}
                              >
                                Nella tua città non è ancora presente un centro
                                convenzionato con brumbrum.
                                <br />
                                Sarai contattato dal nostro servizio clienti per
                                concordare la modalità e il luogo più comodi per
                                il ritiro
                              </div>
                            </BuyCartRow>
                          )}
                      </div>
                    </div>
                  </div>
                ) : null}

                <div className="the-cart">
                  <div
                    className="f-table cart"
                    style={{ marginBottom: '36px' }}
                  >
                    <div className={'section-cart'}>
                      <h5 className={'section-title --reduced'}>
                        Riepilogo Canone
                      </h5>
                      {this.props.nlt && this.props.nlt.selectedCanone && (
                        <BuyCartRow
                          label={'Anticipo'}
                          pricePromozione={
                            <BuyPricePromozione
                              value={`€ ${numeral(
                                this.props.nlt.selectedCanone.anticipo
                              ).format('0[,]00')} (IVA incl.)`}
                            />
                          }
                        />
                      )}
                      {this.props.nlt && this.props.nlt.selectedCanone && (
                        <BuyCartRow
                          label={'Durata'}
                          pricePromozione={
                            <BuyPricePromozione
                              value={`${this.props.nlt.selectedCanone.numero_mensilita} mesi`}
                            />
                          }
                        />
                      )}

                      {this.props.nlt &&
                      this.props.nlt.selectedCanone &&
                      isNltBrumbrum(this.props.product) ? (
                        <BuyCartRow
                          label={'Chilometri inclusi'}
                          pricePromozione={
                            <BuyPricePromozione
                              value={`${numeral(
                                this.props.nlt.selectedCanone.km_inclusi *
                                  (this.props.nlt.selectedCanone
                                    .numero_mensilita /
                                    12)
                              ).format('0[,]00')} (max ${numeral(
                                this.props.nlt.selectedCanone.km_inclusi
                              ).format('0[,]00')}
                            /anno)`}
                            />
                          }
                        />
                      ) : null}
                      {this.props.nlt &&
                      this.props.nlt.selectedCanone &&
                      !isNltBrumbrum(this.props.product) ? (
                        <BuyCartRow
                          label={'Chilometri inclusi'}
                          pricePromozione={
                            <BuyPricePromozione
                              value={numeral(
                                this.props.nlt.selectedCanone.km_inclusi
                              ).format('0[,]00')}
                            />
                          }
                        />
                      ) : null}
                      {this.props.nlt && this.props.nlt.codiceCoupon && (
                        <BuyCartRow
                          label={this.props.nlt.minicartLabelCoupon}
                          pricePromozione={
                            <BuyPricePromozione
                              value={this.props.nlt.codiceCoupon}
                            />
                          }
                        />
                      )}
                      {this.props.nlt &&
                        this.props.nlt.canonePersonalizzato && (
                          <BuyCartRow
                            label={
                              this.props.nlt.minicartLabelCanonePersonalizzato
                            }
                            pricePromozione={
                              <BuyPricePromozione
                                value={this.props.nlt.canonePersonalizzato}
                              />
                            }
                          />
                        )}
                      {this.props.nlt &&
                        this.props.nlt.selectedCanone &&
                        !isNltBrumbrum(this.props.product) && (
                          <BuyCartRow
                            extraCss={'row-canone-riepilogo-canone-mobile'}
                            label={'Canone totale'}
                            pricePromozione={
                              <BuyPricePromozione
                                value={
                                  <React.Fragment>
                                    <b
                                      style={{
                                        fontSize: '14px',
                                        fontWeight: 400,
                                      }}
                                    >
                                      €
                                      {numeral(
                                        getFromFee(
                                          'canone_mensile',
                                          this.props.nlt.selectedCanone
                                        )
                                      ).format('0,0')}
                                    </b>
                                    /mese (IVA incl.)
                                  </React.Fragment>
                                }
                              />
                            }
                          />
                        )}

                      {(this.props.nlt.serviziPlusSelected.length > 0 ||
                        isNltBrumbrum(this.props.product)) &&
                        this.props.nlt.selectedCanone &&
                        this.props.nlt.selectedCanone.canone_mensile && (
                          <div
                            className={`row canoneBase ${
                              isNltBrumbrum(this.props.product) ? 'gray' : ''
                            }`}
                          >
                            <div className="left">
                              <ul>
                                <li style={{ fontWeight: 700 }}>
                                  {isNltBrumbrum(this.props.product)
                                    ? 'Canone mensile'
                                    : 'Canone base'}
                                </li>
                              </ul>
                            </div>
                            <div className="right">
                              <span>
                                <span
                                  className={`${
                                    isNltBrumbrum(this.props.product)
                                      ? 'text-grey800'
                                      : ''
                                  }`}
                                >
                                  €{' '}
                                  {isNltBrumbrum(this.props.product)
                                    ? this.props.nlt.selectedCanone
                                        .canone_mensile +
                                      this.props.nlt.selectedCanone
                                        .cap_variabile_kilometrico
                                    : this.props.nlt.selectedCanone
                                        .canone_mensile}
                                </span>
                                /mese (IVA incl.)
                              </span>
                            </div>
                          </div>
                        )}

                      {this.props.nlt &&
                      this.props.nlt.selectedCanone &&
                      !isNltBrumbrum(this.props.product) ? (
                        <BuyCartRow
                          extraCss={'row-canone-riepilogo-canone-mobile'}
                          label={'Costo chilometrico'}
                          pricePromozione={
                            <BuyPricePromozione
                              value={
                                <React.Fragment>
                                  <b
                                    style={{
                                      fontSize: '14px',
                                      fontWeight: 400,
                                    }}
                                  >
                                    €{this.props.nlt.selectedCanone.fee_km}
                                  </b>
                                  /km (IVA incl.)
                                </React.Fragment>
                              }
                            />
                          }
                        />
                      ) : null}

                      {isNltBrumbrum(this.props.product) && (
                        <div className="row gray">
                          <div className="left" style={{ fontWeight: 700 }}>
                            Canone minimo
                          </div>
                          <div className="right">
                            <span className="text-grey800">
                              €
                              {numeral(
                                this.props.nlt.selectedCanone.canone_mensile
                              ).format()}
                            </span>
                            /mese (IVA incl.)
                          </div>
                          <br style={{ clear: 'both' }} />
                          <div style={{ display: 'block' }}>
                            <p
                              className="nlt-brumbrum-offer-info"
                              style={{ fontSize: '13px' }}
                            >
                              Con l'offerta brumbrum se guidi poco spendi meno e
                              per quest'auto puoi risparmiare fino a €
                              {numeral(
                                this.props.nlt.selectedCanone
                                  .cap_variabile_kilometrico
                              ).format('0[,]00')}
                              . Ogni chilometro percorso ha un costo di €
                              {numeral(
                                this.props.nlt.selectedCanone.fee_km
                              ).format('0[.]00')}
                            </p>
                          </div>
                        </div>
                      )}

                      {this.props.nlt &&
                      valoriLogistica.centroConvenzionatoNome &&
                      valoriLogistica.prezzoLogistica &&
                      isNltBrumbrum(this.props.product) ? (
                        <BuyCartRow
                          extraCss={
                            'row-canone-riepilogo-canone-mobile row-canone-riepilogo-canone-centro-consegna'
                          }
                          label={
                            <span>
                              Consegna:{' '}
                              <i style={{ fontWeight: 300 }}>
                                {valoriLogistica.centroConvenzionatoNome}
                              </i>
                            </span>
                          }
                          pricePromozione={
                            <BuyPricePromozione {...valoriLogistica} />
                          }
                        />
                      ) : null}
                    </div>
                  </div>
                </div>

                <div className="space-20"></div>
                <p className="text-center">
                  <BuyButton
                    classes={`btn btn-primary${
                      this.props.fetching ||
                      (!this.props.nlt.serviziPlusSelected.length &&
                        !this.state.canContinue)
                        ? ' btn-disabled'
                        : ''
                    }`}
                    disabled={
                      !this.props.nlt.serviziPlusSelected.length &&
                      !this.state.canContinue
                    }
                    label={"Prosegui con l'ordine"}
                    update={() => {
                      if (
                        !this.props.nlt.serviziPlusSelected.length &&
                        !this.state.canContinue
                      ) {
                        return false
                      }

                      this.handleProsegui().then(() => {})
                    }}
                  />
                </p>
              </div>
            </div>
          </div>
        )}
      </section>
    )
  }
}

ServiziPlus.propTypes = {
  customer: PropTypes.object,
  fetching: PropTypes.bool,
  logistica: PropTypes.object,
  getNltServiziPlusV1: PropTypes.func,
  nlt: PropTypes.object,
  ordine: PropTypes.object,
  paymentMethodSelected: PropTypes.func,
  phaseChange: PropTypes.func,
  pricing: PropTypes.object,
  product: PropTypes.object,
  putOriniServiziPlusV1: PropTypes.func,
  putOrdiniLogisticaV1: PropTypes.func,
  reroute: PropTypes.func,
  setSelectedServizio: PropTypes.func,
  storeDumpItForce: PropTypes.func,
}

const mapStateToProps = state => ({
  customer: state.customer,
  nlt: state.nlt,
  ordine: state.ordine,
  pricing: state.pricing,
  product: state.product,
  logistica: state.logistica,
  ui: state.ui,
})

const mapDispatchToProps = dispatch => ({
  getNltServiziPlusV1: () => dispatch(getNltServiziPlusV1),
  phaseChange: phase => dispatch(phaseChange(phase)),
  reroute: rerouteTo => dispatch(reroute(rerouteTo)),
  paymentMethodSelected: payload => dispatch(paymentMethodSelected(payload)),
  setSelectedServizio: payload => dispatch(setSelectedServizio(payload)),
  unSetSelectedServizio: payload => dispatch(unSetSelectedServizio(payload)),
  putOriniServiziPlusV1: () => dispatch(putOriniServiziPlusV1),
  putOrdiniLogisticaV1: () => dispatch(putOrdiniLogisticaV1),
  storeDumpItForce: payload => dispatch(storeDumpItForce(payload)),
  unSetAllServiziPlus: () => dispatch(unSetAllServiziPlus()),
  getLogisticaCentriConvenzionatiNltBrumbrum: payload =>
    dispatch(getLogisticaCentriConvenzionatiNltBrumbrum(payload)),
  setLogisticaCentroConvenzionato: payload =>
    dispatch(setLogisticaCentroConvenzionato(payload)),
  setLogisticaCodiceProvincia: payload =>
    dispatch(setLogisticaCodiceProvincia(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ServiziPlus)
